import { useQuery, UseQueryResult } from 'react-query';
import { useLocale } from '../../../../i18n';
import { wgApi } from '../../../app/src/features/api/wgApi';
import useIsNLplan from '../../../common/src/hooks/useIsNLPlan';
import { NaceCodeResponse } from '../types/ApiTypes';
import { NaceCodeList } from '../types/CompanyScanTypes';

export const getNaceCodesBySearchQuery = async (
  searchQuery: string,
  lang: string,
): Promise<NaceCodeResponse> => {
  const path = `v1/api/nace-codes`;
  const { data, isError } = await wgApi.get<NaceCodeResponse>(path, {
    query: {
      lang: lang.toUpperCase(),
      q: searchQuery,
      pagelen: 999,
    },
  });
  if (isError) throw new Error();
  return data;
};

export const getSbiCodesBySearchQuery = async (
  searchQuery: string,
  lang: string,
): Promise<NaceCodeResponse> => {
  const path = `v1/api/sbi-codes`;
  const { data, isError } = await wgApi.get<NaceCodeResponse>(path, {
    query: {
      lang: lang.toUpperCase(),
      q: searchQuery,
      pagelen: 999,
    },
  });
  if (isError) throw new Error();
  return data;
};

export const useNaceCodesQuery = (
  searchQuery: string,
): UseQueryResult<NaceCodeList[], unknown> => {
  const { userLang } = useLocale();
  const { isNL } = useIsNLplan();

  return useQuery<NaceCodeList[]>(
    ['company-scan', 'nace-codes', searchQuery],
    async () => {
      let data;
      if (isNL) {
        data = await getSbiCodesBySearchQuery(searchQuery, userLang);
      } else {
        data = await getNaceCodesBySearchQuery(searchQuery, userLang);
      }
      return data.items.map(({ nace }) => ({
        ...nace,
      }));
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: false,
    },
  );
};
